import { render, staticRenderFns } from "./BaseLoader.vue?vue&type=template&id=c33998f2&"
var script = {}
import style0 from "./BaseLoader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports